import type { DisciplineProgressReportPayload } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineProgressReportUpdateApiOptions {
  disciplineId: string | number
  reportId: number
  payload: DisciplineProgressReportPayload
  onStart?: () => void
  onFinish?: () => void
}

/** `PATCH /admin-api/disciplines/{discipline}/progress-reports/{report}` — answers `[]`; the caller refetches the list. */
export const useDisciplineProgressReportUpdateApi = async (
  options: DisciplineProgressReportUpdateApiOptions,
): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const url = useAdminRoutes('admin.disciplines.api.progress-report', {
    discipline_id: options.disciplineId,
    report_id: options.reportId,
  })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.patch<ApiResponse>(url, options.payload)

    toast.success('Progress report was updated successfully.')

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    options.onFinish?.()
  }
}
